export var INVOICE_STATUS;
(function (INVOICE_STATUS) {
    INVOICE_STATUS["PENDING_PAYMENT"] = "PENDING_PAYMENT";
    INVOICE_STATUS["PAID"] = "PAID";
    INVOICE_STATUS["APPROVED_FOR_REMITTANCE"] = "APPROVED_FOR_REMITTANCE";
    INVOICE_STATUS["CANCELLED"] = "CANCELLED";
    INVOICE_STATUS["PAST_DUE"] = "PAST_DUE";
    INVOICE_STATUS["CHARGE_DISPUTE"] = "CHARGE_DISPUTE";
    INVOICE_STATUS["OTHER"] = "OTHER";
    INVOICE_STATUS["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    INVOICE_STATUS["PAYMENT_SCHEDULED"] = "PAYMENT_SCHEDULED";
})(INVOICE_STATUS || (INVOICE_STATUS = {}));
export var INVOICE_TYPE;
(function (INVOICE_TYPE) {
    INVOICE_TYPE["MONTHLY"] = "MONTHLY";
    INVOICE_TYPE["PARTIAL_MONTH"] = "PARTIAL_MONTH";
    INVOICE_TYPE["TERMINATION"] = "TERMINATION";
    INVOICE_TYPE["INITIAL_INVESTMENT"] = "INITIAL_INVESTMENT";
    INVOICE_TYPE["OTHER"] = "OTHER";
    INVOICE_TYPE["OWNER_MIRROR"] = "OWNER_MIRROR";
    INVOICE_TYPE["DEPOSIT_AGREEMENT"] = "DEPOSIT_AGREEMENT";
})(INVOICE_TYPE || (INVOICE_TYPE = {}));
export var TAX_CODE;
(function (TAX_CODE) {
    TAX_CODE["HST"] = "HST";
    TAX_CODE["TAX_FREE"] = "TAX_FREE";
    TAX_CODE["LTT"] = "LTT";
})(TAX_CODE || (TAX_CODE = {}));
export var TransactionEventType;
(function (TransactionEventType) {
    TransactionEventType["CREATE"] = "CREATE";
    TransactionEventType["UPDATE"] = "UPDATE";
})(TransactionEventType || (TransactionEventType = {}));
//# sourceMappingURL=Invoice.js.map